export default {
	data() {
		return {
			modelState: {},
		};
	},
	methods: {
		validateProperty(name) {
			const errors = [];

			if (this.modelState.errors && this.modelState.errors[name]) {
				const prop = this.modelState.errors[name];

				prop.forEach((error) => {
					errors.push(error);
				});
			}

			return errors;
		},
		modelError() {
			const model = 'Model';
			if (this.modelState.errors && this.modelState.errors[model]) {
				const prop = this.modelState.errors[model];

				return prop[0];
			}

			return null;
		},
		getRandomInt(paMax) {
			const max = paMax || 10000000;
			return Math.floor(Math.random() * Math.floor(max));
		},
	},
};
